




























































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import _ from "lodash";
import Camera from "./equipment_camera.vue";
import SaleCounter from "./equipment_sale_counter.vue";

@Component({
  components: {
    Camera,
    SaleCounter
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() mainEquipment!: any;

  @Prop() mainEquipOptions!: any;

  @Prop() grounds!: any;

  @Prop() itm!: any;

  @Prop() idx!: number;

  @Prop() addControlRule!: (...args: any[]) => any;

  @Prop() removeControlRule!: (...args: any[]) => any;

  @Prop() removeMainItem!: (...args: any[]) => any;

  cameraModalVisible = false;

  saleCounterModalVisible = false;

  mainEquipIdx = 0;

  manageCamera(idx: number) {
    this.mainEquipIdx = idx;
    this.cameraModalVisible = true;
  }

  selectType(val: any, idx: number) {
    // console.log(typeof val);
    switch (val) {
      case "2":
        this.mainEquipment[idx].control_rule = [
          { key: "ip", value: "192.168.1.11" },
          { key: "port", value: "8000" },
          { key: "login", value: "admin" },
          { key: "password", value: "" },
          { key: "userMax", value: "5000" }
        ];
        break;
      case "3":
        this.mainEquipment[idx].control_rule = [
          { key: "com", value: "/dev/ttyS0" },
          { key: "baud", value: "9600" }
        ];
        break;
      case "4":
        this.mainEquipment[idx].control_rule = [
          { key: "com", value: "/dev/ttyS4" },
          { key: "baud", value: "2400" }
        ];
        break;
      case "5":
        this.mainEquipment[idx].control_rule = [
          { key: "brand", value: "海康威视" }
          // { key: 'model', value: '' },
          // { key: 'serialnumber', value: '' },
          // { key: 'ip', value: '' },
          // { key: 'network', value: '' },
        ];
        break;
      case "7":
        this.mainEquipment[idx].control_rule = [
          { key: "com", value: "" },
          { key: "baud", value: "" },
          { key: "start", value: "1" },
          { key: "end", value: "14" }
        ];
        break;
      default:
        break;
    }
    const obj = _.find(this.mainEquipOptions, (o: any) => o.id === val);

    this.mainEquipment[idx].name = _.get(obj, "name");
  }

  hideCameraModal() {
    this.cameraModalVisible = false;
  }

  manageCounter(idx: number) {
    this.mainEquipIdx = idx;
    this.saleCounterModalVisible = true;
  }

  hideCounterModal() {
    this.saleCounterModalVisible = false;
  }
}
